<template>
    <div class="row top-widgets-row">
        <div class="col-md-2 widgets-col"  @click="filterByStatus('new')">
            <div class="payroll-counter-box active-employee">
                <div class="top-box">
                    <span class="title"> <em class="rollover">{{this.new}}</em> </span>
                    <p> New</p>
                </div>
                <div class="foot-box"></div>
            </div>
        </div>
        <div class="col-md-2 widgets-col" @click="filterByStatus('in progress')">
            <div class="payroll-counter-box payroll-processed">
                <div class="top-box">
                    <span class="title"> <em class="rollover"> {{this.inProgress}}</em> </span>
                    <p>In Progress </p>
                </div>
                <div class="foot-box"></div>
            </div>
        </div>
        <div class="col-md-2 widgets-col" @click="filterByStatus('on Hold')">
            <div class="payroll-counter-box last-payroll">
                <div class="top-box">
                    <span class="title"> <em class="rollover">{{this.onHold}} </em> </span>
                    <p> On Hold </p>
                </div>
                <div class="foot-box"></div>
            </div>
        </div>
        <div class="col-md-2 widgets-col" @click="filterByStatus('resolved')">
            <div class="payroll-counter-box last-payroll">
                <div class="top-box">
                    <span class="title"> <em class="rollover">{{this.resolved}} </em> </span>
                    <p> Resolved</p>
                </div>
                <div class="foot-box"></div>
            </div>
        </div>
        <div class="col-md-2 widgets-col" @click="filterByStatus('closed')">
            <div class="payroll-counter-box last-payroll">
                <div class="top-box">
                    <span class="title"> <em class="rollover"> {{this.closed}}</em> </span>
                    <p>Closed</p>
                </div>
                <div class="foot-box"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                new: '',
                inProgress: '',
                onHold: '',
                resolved: '',
                closed: ''
            };
        },
        mounted() {
            this.$Progress.start();
            this.getStatusAnalytics()
        },
        methods: {
            getStatusAnalytics() {
                axios.get('/api/enquiryAnalytics')
                    .then(res => {
                        this.new = res.data.new,
                            this.inProgress = res.data.inProgress,
                            this.onHold = res.data.onHold,
                            this.resolved = res.data.resolved,
                            this.closed = res.data.closed,
                            this.$Progress.finish();
                    }).catch(err => {
                    console.log(err);
                });
            },
            filterByStatus(status) {
                this.$emit('statusClicked', status);
            },
        },
    }
</script>
<style scoped>
    .col-md-2 {
        flex: 0 0 20%;
        max-width: 20%;
    }
    .payroll-counter-box .top-box {
        border: none;
    }
</style>
